module.exports = __webpack_public_path__ + "img/water-consumption.a694b17c.svg";